import TCascader from './cascader.vue'

TCascader.install = Vue => {
  Vue.component(TCascader.name, TCascader)
}

export {
  TCascader
}



// WEBPACK FOOTER //
// ./src/module/cascader/index.js